export default {
  'm-money-input': {
    'set-full-amount': 'Max',
  },
}
